export const FOCUS_AREA_LINKS = {
  'sport-performance': 'https://www.weriise.co/for-your-sport-performance',
  energy: 'https://www.weriise.co/for-your-energy',
  focus: 'https://www.weriise.co/for-your-focus',
  mood: 'https://www.weriise.co/for-your-mood',
  sleep: 'https://www.weriise.co/for-your-sleep',
  stress: 'https://www.weriise.co/for-your-stress',
  digestion: 'https://www.weriise.co/blogs/digestion-riise-supplement',
  'immune-system': 'https://www.weriise.co/for-your-immune-system',
  skin: 'https://www.weriise.co/blogs/skin-riise-supplement',
  hair: 'https://www.weriise.co/blogs/hair-riise-supplement',
  nails: 'https://www.weriise.co/blogs/nails-riise-supplement',
  heart: 'https://www.weriise.co/blogs/heart-riise-supplement',
  'muscle-pain': 'https://www.weriise.co/blogs/muscle-pain-riise-supplement',
  eyes: 'https://www.weriise.co/blogs/eyes-riise-supplement',
  'bones-and-joints': 'https://www.weriise.co/blogs/bones-and-joints-riise-supplement',
  'Sport Performance': 'https://www.weriise.co/for-your-sport-performance',
  Energy: 'https://www.weriise.co/for-your-energy',
  Focus: 'https://www.weriise.co/for-your-focus',
  Mood: 'https://www.weriise.co/for-your-mood',
  Sleep: 'https://www.weriise.co/for-your-sleep',
  Stress: 'https://www.weriise.co/for-your-stress',
  Digestion: 'https://www.weriise.co/blogs/digestion-riise-supplement',
  'Immune System': 'https://www.weriise.co/for-your-immune-system',
  Skin: 'https://www.weriise.co/blogs/skin-riise-supplement',
  Hair: 'https://www.weriise.co/blogs/hair-riise-supplement',
  Nails: 'https://www.weriise.co/blogs/nails-riise-supplement',
  Heart: 'https://www.weriise.co/blogs/heart-riise-supplement',
  'Muscle Pain': 'https://www.weriise.co/blogs/muscle-pain-riise-supplement',
  Eyes: 'https://www.weriise.co/blogs/eyes-riise-supplement',
  'Bones and Joints': 'https://www.weriise.co/blogs/bones-and-joints-riise-supplement',
  'Sportliche Leistung': 'https://www.weriise.co/for-your-sport-performance',
  Energie: 'https://www.weriise.co/for-your-energy',
  Konzentration: 'https://www.weriise.co/for-your-focus',
  Stimmung: 'https://www.weriise.co/for-your-mood',
  Schlaf: 'https://www.weriise.co/for-your-sleep',
  Verdauung: 'https://www.weriise.co/blogs/digestion-riise-supplement',
  Immunsystem: 'https://www.weriise.co/for-your-immune-system',
  Haut: 'https://www.weriise.co/blogs/skin-riise-supplement',
  Haare: 'https://www.weriise.co/blogs/hair-riise-supplement',
  Nägel: 'https://www.weriise.co/blogs/nails-riise-supplement',
  Herz: 'https://www.weriise.co/blogs/heart-riise-supplement',
  Muskelschmerzen: 'https://www.weriise.co/blogs/muscle-pain-riise-supplement',
  Augen: 'https://www.weriise.co/blogs/eyes-riise-supplement',
  'Knochen und Gelenke': 'https://www.weriise.co/blogs/bones-and-joints-riise-supplement',
};

export const hashEmail = async (email) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(email);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};

export const getFBP = () => {
  const match = document.cookie.match(/_fbp=([^;]+)/);
  return match ? match[1] : null;
};

export const getCookie = (name) => {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
};

export const saveMetaParamsBeforeRedirect = () => {
  const fbp = window?.clientParamBuilder?.getFbp();
  const fbc = window?.clientParamBuilder?.getFbc();
  const externalId = sessionStorage.getItem('externalId');
  if (fbp) localStorage.setItem('_meta_fbp', fbp);
  if (fbc) localStorage.setItem('_meta_fbc', fbc);
  if (externalId) localStorage.setItem('_meta_external_id', externalId);
};

export const getMetaParamsAfterRedirect = () => {
  const fbp = localStorage.getItem('_meta_fbp') || window?.clientParamBuilder?.getFbp();
  const fbc = localStorage.getItem('_meta_fbc') || window?.clientParamBuilder?.getFbc();
  const externalId = localStorage.getItem('_meta_external_id') || sessionStorage.getItem('externalId');
  if (externalId) {
    sessionStorage.setItem('externalId', externalId);
  }
  localStorage.removeItem('_meta_fbp');
  localStorage.removeItem('_meta_fbc');
  localStorage.removeItem('_meta_external_id');
  return { fbp, fbc, externalId };
};

export const getValidFbParam = (fbParam) => {
  console.log('fbParam', fbParam);
    if (!fbParam) return null;

    const parts = fbParam.split('.');
    if (parts.length < 4) return null;

    const ts = Number(parts[2]);
    if (Number.isNaN(ts)) return null;

    const ageDays = (Date.now() - ts) / (1000 * 60 * 60 * 24);
    console.log('ageDays', ageDays);

    // expiry of 90 days for fbp and fbc
    return ageDays <= 90 ? fbParam : null;
  };

export const COUNTRIES = [
  { code: 'AL', name: 'Albania' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AT', name: 'Austria' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'EE', name: 'Estonia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'DE', name: 'Germany' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GR', name: 'Greece' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IT', name: 'Italy' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MT', name: 'Malta' },
  { code: 'MC', name: 'Monaco' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'NO', name: 'Norway' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Romania' },
  { code: 'SM', name: 'San Marino' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'ES', name: 'Spain' },
  { code: 'SE', name: 'Sweden' },
  { code: 'VA', name: 'Vatican City' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'GB', name: 'United Kingdom' },
];
export const COUNTRY_OPTIONS = [
      { value: '', labelKey: 'Quiz_Country_SelectCountry' },
      { value: 'England', labelKey: 'Quiz_Country_England' },
      { value: 'Scotland', labelKey: 'Quiz_Country_Scotland' },
      { value: 'Wales', labelKey: 'Quiz_Country_Wales' },
      { value: 'Northern Ireland', labelKey: 'Quiz_Country_NorthernIreland' },
      { value: 'Albania', labelKey: 'Quiz_Country_Albania' },
      { value: 'Austria', labelKey: 'Quiz_Country_Austria' },
      { value: 'Belgium', labelKey: 'Quiz_Country_Belgium' },
      { value: 'Bulgaria', labelKey: 'Quiz_Country_Bulgaria' },
      { value: 'Croatia', labelKey: 'Quiz_Country_Croatia' },
      { value: 'Cyprus', labelKey: 'Quiz_Country_Cyprus' },
      { value: 'Czech Republic', labelKey: 'Quiz_Country_CzechRepublic' },
      { value: 'Denmark', labelKey: 'Quiz_Country_Denmark' },
      { value: 'Estonia', labelKey: 'Quiz_Country_Estonia' },
      { value: 'Finland', labelKey: 'Quiz_Country_Finland' },
      { value: 'France', labelKey: 'Quiz_Country_France' },
      { value: 'Germany', labelKey: 'Quiz_Country_Germany' },
      { value: 'Greece', labelKey: 'Quiz_Country_Greece' },
      { value: 'Hungary', labelKey: 'Quiz_Country_Hungary' },
      { value: 'Iceland', labelKey: 'Quiz_Country_Iceland' },
      { value: 'Ireland', labelKey: 'Quiz_Country_Ireland' },
      { value: 'Italy', labelKey: 'Quiz_Country_Italy' },
      { value: 'Latvia', labelKey: 'Quiz_Country_Latvia' },
      { value: 'Lithuania', labelKey: 'Quiz_Country_Lithuania' },
      { value: 'Luxembourg', labelKey: 'Quiz_Country_Luxembourg' },
      { value: 'Malta', labelKey: 'Quiz_Country_Malta' },
      { value: 'Netherlands', labelKey: 'Quiz_Country_Netherlands' },
      { value: 'Norway', labelKey: 'Quiz_Country_Norway' },
      { value: 'Poland', labelKey: 'Quiz_Country_Poland' },
      { value: 'Portugal', labelKey: 'Quiz_Country_Portugal' },
      { value: 'Romania', labelKey: 'Quiz_Country_Romania' },
      { value: 'Slovakia', labelKey: 'Quiz_Country_Slovakia' },
      { value: 'Slovenia', labelKey: 'Quiz_Country_Slovenia' },
      { value: 'Spain', labelKey: 'Quiz_Country_Spain' },
      { value: 'Sweden', labelKey: 'Quiz_Country_Sweden' },
      { value: 'Switzerland', labelKey: 'Quiz_Country_Switzerland' },
      { value: 'Ukraine', labelKey: 'Quiz_Country_Ukraine' },
    ];
